//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Multiselect from 'vue-multiselect'

import RbModal from '@/elements/modal/rb-modal.vue'

import { mapGetters } from 'vuex'
import axios from 'axios'

import {
  getRoeCookie,
  getSortedCountries,
  removeRoeCookie,
  removeSetCurrencyCookie,
  setCurrencyPreference,
  setRoeCookie,
} from '@/scripts/libs/country-selector'
import { NoEcommerce } from '@/scripts/libs/no-ecommerce'

export default {
  name: 'rb-country-selector',
  components: {
    RbModal,
    Multiselect,
  },
  props: {
    countryselectorUrl: String,
    paymentmethodsUrl: String,
    selected: String,
    labelModal: String,
    searchLabel: String,
    searchLabelLoading: String,
    searchLabelButton: String,
    disabled: String,
    promotionAvailable: { type: Boolean, default: false },
    promotionValue: { type: String, default: '' },
  },
  data() {
    return {
      locales: [],
      filteredLocales: [],
      international: {},
      modalActive: false,
      value: undefined,
      canRenderButton: false,
      loading: false,
      flagSelected: null,
      paymentsMethod: [],
      currency: null,
      currencyLabel: null,
      currentCountry: null,
      paymentsLabel: null,
      benefitsLabel: null,
      shippingLabel: null,
      submitLabel: null,
      typeLabel: null,
      benefit: null,
    }
  },
  computed: {
    ...mapGetters(['translation']),
    paymentMethodsAvailable() {
      return this.paymentsMethod.length > 0
    },
    isDisabled() {
      return !!this.disabled
    },
    currencyAvailable() {
      if (this.currency) {
        return this.currency.length > 0
      } else {
        return false
      }
    },
    getFlagSelectedLabel() {
      return this.flagSelected && this.flagSelected.label
    },
  },
  watch: {
    modalActive(newVal) {
      if (!newVal) {
        return
      }
      this.getCountryInformation()
    },
    value(newVal, oldVal) {
      if (!newVal || !oldVal) {
        return
      }
      this.getCountryInformation()
    },
  },
  mounted() {
    this.fillLocales(getSortedCountries())
    if (this.selected.includes('/eu')) {
      this.manageRoeSelection()
    } else if (
      NoEcommerce.getNoEcommerceCountry() ||
      NoEcommerce.isStoreInNoEcommerceCountries(this.value?.akamaiCC)
    ) {
      this.manageNoEcomSelection()
    } else {
      this.manageNonRoeSelection()
    }
  },
  methods: {
    getCountryInformation() {
      this.loading = true
      if (
        this.paymentmethodsUrl &&
        !NoEcommerce.isStoreInNoEcommerceCountries(this.value?.akamaiCC) &&
        this.value?.id
      ) {
        axios
          .get(this.paymentmethodsUrl, {
            params: {
              storeId: this.value.id,
              langId: this.value.langId,
            },
          })
          .then(({ data }) => {
            // country with storeID and payment methods available
            this.paymentsMethod = data.payment.paymentsMethod
            this.currency = this.value.currency
            if (this.value && this.value.labels) {
              this.currencyLabel = this.value.labels.currencyLabel
              this.paymentsLabel = this.value.labels.paymentsLabel
              this.benefitsLabel = this.value.labels.benefitsLabel
              this.shippingLabel = this.value.labels.shippingLabel
              this.submitLabel = this.value.labels.submitLabel
              this.typeLabel = this.value.labels.typeLabel
            }
            this.benefit = data.benefit
            this.loading = false
            this.canRenderButton = this.currentCountry !== this.value
          })
      } else if (!this.value) {
        // case same country
        this.loading = false
        this.canRenderButton = this.currentCountry !== this.value
      } else {
        // country without storeID and payment methods available
        this.paymentsMethod = ''
        this.benefit = ''
        this.benefitsLabel = ''
        this.currency = this.value.currency
        this.currencyLabel = this.value.labels && this.value.labels.currencyLabel
        this.shippingLabel = this.value.labels && this.value.labels.shippingLabel
        this.submitLabel = this.value.labels && this.value.labels.submitLabel
        this.typeLabel = this.value.labels && this.value.labels.typeLabel
        this.loading = false
        this.canRenderButton = this.currentCountry !== this.value
      }
    },
    manageRoeSelection() {
      const euSelected = getRoeCookie()
      if (euSelected) {
        this.value = this.locales.find((v) => euSelected.includes(v.akamaiCC))
      } else {
        this.value = this.locales.find((v) => this.selected.includes(v.url))
      }
      this.flagSelected = this.value
        ? {
            iconFlag: this.value.iconFlag,
            label: this.value.label,
          }
        : null
      this.currentCountry = this.value
    },
    manageNoEcomSelection() {
      const noEcomSelected = NoEcommerce.getNoEcommerceCountry()
      if (noEcomSelected) {
        this.value = this.locales.find((country) => noEcomSelected === country.akamaiCC)
      } else {
        this.value = this.locales.find((country) => this.selected === country.id)
      }
      this.flagSelected = this.value
        ? {
            iconFlag: this.value.iconFlag,
            label: this.value.label,
          }
        : null
      this.currentCountry = this.value
    },
    manageNonRoeSelection() {
      removeRoeCookie()
      NoEcommerce.removeNoEcommerceCookie()
      removeSetCurrencyCookie()
      this.value = this.locales.find((v) => this.selected.includes(v.url))
      this.flagSelected = this.value
        ? {
            iconFlag: this.value.iconFlag,
            label: this.value.label,
          }
        : null
      this.currentCountry = this.value
    },
    fillLocales(locales) {
      this.locales = locales
      this.findCoincidences('')
    },
    openModal() {
      this.modalActive = true
    },
    closeModal() {
      this.modalActive = false
    },
    changeCountry() {
      NoEcommerce.removeNoEcommerceCookie()
      removeRoeCookie()
      removeSetCurrencyCookie()
      let requestedCountryURL = ''
      if (!this.value) {
        return
      }
      localStorage.clear()
      sessionStorage.clear()

      let selectedCookie = undefined

      if (this.value.url.includes('/eu')) {
        setRoeCookie(this.value.akamaiCC)
        selectedCookie = getRoeCookie()
      } else if (NoEcommerce.isStoreInNoEcommerceCountries(this.value?.akamaiCC)) {
        NoEcommerce.setNoEcommerceCookie(this.value.akamaiCC)
        selectedCookie = this.value?.akamaiCC
      } else {
        NoEcommerce.removeNoEcommerceCookie()
        removeRoeCookie()
        removeSetCurrencyCookie()
      }
      if (window.location.origin.includes('.cn')) {
        const urlreplaced = window.location.origin.replace('.cn', '')
        requestedCountryURL = urlreplaced + this.value.url
      } else {
        requestedCountryURL = window.location.origin + this.value.url
      }
      setCurrencyPreference(
        this.closeModal,
        requestedCountryURL,
        selectedCookie,
        this.currency,
        this.value.currencyROEValue
      )
    },
    findCoincidences(searchQuery) {
      const val = searchQuery.trim().toLowerCase()

      this.filteredLocales = this.locales.filter((localItem) => {
        const label = localItem.label.toLowerCase()
        const synonymous = localItem.synonymous.filter((synonym) => {
          return synonym.toLowerCase().startsWith(val)
        })
        return label.startsWith(val) || synonymous.length > 0
      })
    },
  },
}
